const closest = require('closest');

class ClearFormFields {
  constructor() {
    const button = document.querySelector('.js-form-clear-button');
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.clearFormFields(button);
      });
    }
  }

  clearFormFields(button) {
    const parent = closest(button, 'form');
    const fields = parent.querySelectorAll('input, textarea, select');
    [].slice.call(fields).forEach(field => {
      if (field.type === 'select-one') {
        field.selectedIndex = 0;
      } else {
        field.value = '';
      }
    });
  }
}

export default ClearFormFields;
